import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  errorCodes: {},
  isLoading: false,
  error: "",
  hasData: false
};
const mmbErrorCodeSlice = createSlice({
  name: "mmbErrorCodes",
  initialState,
  reducers: {
    mmbErrorCodeRequest: state => {
      state.isLoading = true;
    },
    mmbErrorCodeSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.errorCodes = action.payload;
    },
    mmbErrorCodeFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    }
  }
});
export const {
  mmbErrorCodeRequest,
  mmbErrorCodeSuccess,
  mmbErrorCodeFailure
} = mmbErrorCodeSlice.actions;
export default mmbErrorCodeSlice.reducer;